import React, { memo, useState, useEffect } from 'react'
import propTypes from 'prop-types'
import axios from 'axios'
import Button from '../../Button'
import SearchResults from '../SearchResults'
import SelectImageType from '../SelectImageType'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import './styles.scss'

const SearchByCategory = ({
  chooseImage,
  closeModal,
  imageTypes,
  setImageTypes,
}) => {
  const [searchString, setSearchString] = useState('')
  const [categories, setCategories] = useState([])
  const [results, setResults] = useState([])
  const [resultsTotal, setResultsTotal] = useState(0)
  const [filteredResults, setFilteredResults] = useState([])
  const [path, setPath] = useState('')
  const [loading, setLoading] = useState(false)
  const [initialLoadDone, setInitialLoadDone] = useState(false)
  const apiUrl = process.env.REACT_APP_KUVAPANKKI_API_URL

  const getImageTypeLabel = (type) => {
    const imageTypeLabels = {
      ARASAAC: 'arasaac',
      KUVAKO: 'kuvako',
      Mulberry: 'mulberry',
      Piirroskuva: 'drawing',
      Sclera: 'sclera',
      Toisto: 'toisto',
      Valokuva: 'photo',
      Viittomakuva: 'sign',
    }
    return imageTypeLabels[type] || type
  }

  useEffect(() => {
    const getRootCategories = async () => {
      const res = await axios.get(`${apiUrl}/browse/class?lang=fi`)
      const data = res.data
      setCategories(data.children)
    }
    const searchDatabase = async () => {
      try {
        const res = await axios.get(`${apiUrl}/browse/class/${searchString}?lang=fi`)
        const data = res.data
        setPath(data.path)
        if (data.children.length && !data.images.length) {
          setCategories(data.children)
        } else {
          setResults(data)
          setCategories([])
        }
        if (res) setLoading(false)
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error('error ', e)
      }
    }

    if (loading || !initialLoadDone) {
      if (searchString === '') {
        getRootCategories()
        setInitialLoadDone(true)
      } else {
        searchDatabase()
      }
    }
  }, [searchString, loading])

  const searchCategory = (cat) => {
    setLoading(true)
    setSearchString(cat)
  }

  const resetCategories = () => {
    setPath('')
    setResults([])
    setSearchString('')
    setInitialLoadDone(false)
  }

  useEffect(() => {
    if (results?.images?.length && imageTypes?.length < 8) {
      const shallowCopyOfResults = { ...results }
      const filteredImages = shallowCopyOfResults.images.filter((image) =>
        imageTypes.includes(getImageTypeLabel(image.type))
      )
      setFilteredResults({ ...shallowCopyOfResults, images: filteredImages })
      setResultsTotal(filteredImages?.length || 0)
    } else {
      setFilteredResults(results)
      setResultsTotal(results?.images?.length || 0)
    }
  }, [results, imageTypes])

  return (
    <div className="search-container">
      <div className="search-buttons-container">
        {path !== '' ? (
          <Button className="return-to-search-button" onClick={resetCategories}>
            <div className="icon-button-content">
              <FontAwesomeIcon
                icon="arrow-left"
                className="icon"
                style={{ marginRight: '5px' }}
              />
              Alkuun
            </div>
          </Button>
        ) : (
          <></>
        )}
        <SelectImageType imageTypes={imageTypes} setImageTypes={setImageTypes} />
        <Button
          onClick={() => searchCategory(searchString)}
          className="search-button"
          disabled={
            (imageTypes && imageTypes.length === 0) || categories?.length > 0
          }
        >
          Hae
        </Button>
      </div>
      {path && (
        <div>
          <h3 className="search-results-header">
            {path} {resultsTotal > 0 ? `(${resultsTotal})` : null}
          </h3>
        </div>
      )}
      {loading ? (
        <div className="spinner-content">
          <FontAwesomeIcon icon="spinner" spin className="spinner-icon" size="2x" />
          <p>Ladataan...</p>
        </div>
      ) : (
        <ul className="categories-list">
          {categories?.length && !results?.images?.length
            ? categories.map((cat) => {
                return (
                  <li key={cat}>
                    <Button
                      onClick={() => searchCategory(cat)}
                      className="category-list-button"
                      label={`Etsi kategoriasta ${cat}.`}
                    >
                      {cat}
                    </Button>
                  </li>
                )
              })
            : null}
        </ul>
      )}
      {filteredResults?.images?.length > 0 ? (
        <SearchResults
          results={filteredResults}
          chooseImage={chooseImage}
          closeModal={closeModal}
          isSearchTab={false}
          setResultsTotal={setResultsTotal}
        />
      ) : null}
    </div>
  )
}

SearchByCategory.propTypes = {
  chooseImage: propTypes.func.isRequired,
  closeModal: propTypes.func.isRequired,
  imageTypes: propTypes.instanceOf(Object).isRequired,
  setImageTypes: propTypes.func.isRequired,
}

export default memo(SearchByCategory)
